import api from './api';

// Servicio de autenticación
export const authService = {
  // Iniciar sesión
  login: async (username, password) => {
    const response = await api.post('/token/', { username, password }, {
      baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000/api',
    });
    return response.data;
  },

  // Obtener perfil del usuario
  getPerfil: async () => {
    const response = await api.get('/usuarios/usuarios/perfil/');
    return response.data;
  },

  // Cerrar sesión
  logout: () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
  },
};

// Servicio de requerimientos
export const requerimientoService = {
  // Obtener todos los requerimientos
  getAll: async (params = {}) => {
    const response = await api.get('/requerimientos/', { params });
    return response.data;
  },

  // Obtener un requerimiento por ID
  getById: async (id) => {
    const response = await api.get(`/requerimientos/${id}/`);
    return response.data;
  },

  // Crear un nuevo requerimiento
  create: async (data) => {
    const response = await api.post('/requerimientos/', data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  // Actualizar un requerimiento (solo creador/admin)
  update: async (id, data) => {
    const response = await api.patch(`/requerimientos/${id}/`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  // Registrar un pago (parcial o completo)
  registrarPago: async (id, monto) => {
    const response = await api.post(`/requerimientos/${id}/registrar_pago/`, { monto });
    return response.data;
  },

  // Cambiar estado de un requerimiento
  cambiarEstado: async (id, nuevoEstado, comentario = '') => {
    const response = await api.patch(`/requerimientos/${id}/cambiar_estado/`, {
      nuevo_estado: nuevoEstado,
      comentario,
    });
    return response.data;
  },

  // Aplicar criticidad (VP Comercial/Operativa)
  aplicarCriticidad: async (id, criticidad) => {
    const response = await api.post(`/requerimientos/${id}/aplicar_criticidad/`, {
      criticidad,
    });
    return response.data;
  },

  // Asignar proveedor (VP Administrativa)
  asignarProveedor: async (id, data) => {
    const response = await api.post(`/requerimientos/${id}/asignar_proveedor/`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  // Obtener requerimientos por estado
  porEstado: async (estado) => {
    const response = await api.get('/requerimientos/por_estado/', {
      params: { estado },
    });
    return response.data;
  },

  // Obtener requerimientos por nivel de aprobación
  porNivel: async () => {
    const response = await api.get('/requerimientos/por_nivel/');
    return response.data;
  },

  // Bandeja de entrada (área receptora/VPs/Presidente)
  bandejaEntrada: async () => {
    const response = await api.get('/requerimientos/bandeja_entrada/');
    return response.data;
  },

  // Bandeja de enviados (analistas/emisores)
  bandejaEnviados: async (filtros = {}) => {
    const response = await api.get('/requerimientos/bandeja_enviados/', { params: filtros });
    return response.data;
  },

  // Obtener línea de tiempo de un requerimiento
  getLineaTiempo: async (requerimientoId) => {
    const response = await api.get('/linea-tiempo/', {
      params: { requerimiento: requerimientoId },
    });
    return response.data;
  },
};

// Servicio de dashboard
export const dashboardService = {
  // Dashboard general (admin)
  getGeneral: async () => {
    const response = await api.get('/dashboard/general/');
    return response.data;
  },

  // Dashboard con filtros
  getFiltrado: async (filtros = {}) => {
    const response = await api.get('/dashboard/filtrado/', { params: filtros });
    return response.data;
  },

  // Obtener auditoría completa (Presidente)
  getAuditoria: async (filtros = {}) => {
    const response = await api.get('/dashboard/auditoria/', { params: filtros });
    return response.data;
  },

  // Configuración del sistema
  getConfiguracion: async () => {
    const response = await api.get('/dashboard/configuracion/');
    return response.data;
  },

  // Guardar configuración del sistema
  guardarConfiguracion: async (data) => {
    const response = await api.patch('/dashboard/configuracion/', data);
    return response.data;
  },

  // Obtener estado público del sistema (Mantenimiento, Nombre)
  getEstadoSistema: async () => {
    const response = await api.get('/dashboard/estado-sistema/');
    return response.data;
  },
};

// Servicio de BCV
export const bcvService = {
  // Obtener la tasa del día de hoy
  getTasaHoy: async () => {
    const response = await api.get('/bcv/tasa-hoy/');
    return response.data;
  },
};

// Servicio de Vicepresidencias y Gerencias (Organización)
export const orgService = {
  // Vicepresidencias
  getVicepresidencias: async () => {
    const response = await api.get('/usuarios/vicepresidencias/');
    return response.data;
  },
  createVicepresidencia: async (data) => {
    const response = await api.post('/usuarios/vicepresidencias/', data);
    return response.data;
  },
  updateVicepresidencia: async (id, data) => {
    const response = await api.patch(`/usuarios/vicepresidencias/${id}/`, data);
    return response.data;
  },

  // Gerencias
  getGerencias: async (params = {}) => {
    const response = await api.get('/usuarios/gerencias/', { params });
    return response.data;
  },
  createGerencia: async (data) => {
    const response = await api.post('/usuarios/gerencias/', data);
    return response.data;
  },
  updateGerencia: async (id, data) => {
    const response = await api.patch(`/usuarios/gerencias/${id}/`, data);
    return response.data;
  },
  deleteGerencia: async (id) => {
    const response = await api.delete(`/usuarios/gerencias/${id}/`);
    return response.data;
  },
};

// Servicio de usuarios (solo admin)
export const usuarioService = {
  // Obtener todos los usuarios
  getAll: async () => {
    const response = await api.get('/usuarios/usuarios/');
    return response.data;
  },

  // Crear usuario
  create: async (data) => {
    const response = await api.post('/usuarios/usuarios/', data);
    return response.data;
  },

  // Actualizar usuario
  update: async (id, data) => {
    const response = await api.patch(`/usuarios/usuarios/${id}/`, data);
    return response.data;
  },

  // Cambiar contraseña de usuario (admin)
  cambiarPassword: async (id, nuevaPassword) => {
    const response = await api.post(`/usuarios/usuarios/${id}/cambiar_password/`, {
      nueva_password: nuevaPassword,
    });
    return response.data;
  },
};

// Servicio de ubicación geográfica (Venezuela)
export const ubicacionService = {
  // Obtener todos los estados
  getEstados: async () => {
    const response = await api.get('/ubicacion/estados/');
    return response.data;
  },

  // Obtener municipios por estado
  getMunicipios: async (estadoId) => {
    const response = await api.get('/ubicacion/municipios/', {
      params: { estado_id: estadoId },
    });
    return response.data;
  },

  // Obtener parroquias por municipio
  getParroquias: async (municipioId) => {
    const response = await api.get('/ubicacion/parroquias/', {
      params: { municipio_id: municipioId },
    });
    return response.data;
  },
};

// Servicio de proveedores
export const proveedorService = {
  getTiposProveedores: async () => {
    const response = await api.get('/tipos-proveedores/');
    return response.data;
  },
  crearTipoProveedor: async (data) => {
    const response = await api.post('/tipos-proveedores/', data);
    return response.data;
  },
  updateTipoProveedor: async (id, data) => {
    const response = await api.patch(`/tipos-proveedores/${id}/`, data);
    return response.data;
  },
  getTiposDocumentos: async () => {
    const response = await api.get('/tipos-documentos/');
    return response.data;
  },
  getProveedores: async (params = {}) => {
    const response = await api.get('/proveedores/', { params });
    return response.data;
  },
  crearProveedor: async (data) => {
    const response = await api.post('/proveedores/', data);
    return response.data;
  },
  updateProveedor: async (id, data) => {
    const response = await api.patch(`/proveedores/${id}/`, data);
    return response.data;
  },
};

